import { registerPlugin } from '@capacitor/core';

/**
 * Bridge natif `@capacitor/local-notifications` via `registerPlugin` de
 * @capacitor/core : proxy SYNCHRONE, aucun chunk web à charger.
 *
 * ⚠️ On ne fait PLUS `import('@capacitor/local-notifications')` : l'entrée du
 * paquet déclare `web: () => import('./web')`, et c'est exactement le piège
 * documenté pour `@capacitor-firebase/messaging` — dans le WKWebView iOS un
 * import dynamique de plugin peut rester bloqué à jamais (ni resolve ni
 * reject), et la notification locale ne serait jamais programmée, en silence.
 * Cf. `firebase-messaging.ts` et FIREBASE_SETUP.md (étape 6b).
 *
 * Seules les méthodes réellement utilisées sont déclarées.
 */
export interface LocalNotificationSchedule {
  id: number;
  title: string;
  body: string;
  schedule?: { at: Date; allowWhileIdle?: boolean };
  extra?: Record<string, unknown>;
}

export interface LocalNotificationsBridge {
  checkPermissions(): Promise<{ display: string }>;
  requestPermissions(): Promise<{ display: string }>;
  schedule(options: { notifications: LocalNotificationSchedule[] }): Promise<unknown>;
  cancel(options: { notifications: { id: number }[] }): Promise<void>;
  /** Notifications déjà programmées (pour ne pas reprogrammer pour rien). */
  getPending(): Promise<{ notifications: { id: number }[] }>;
}

export const LocalNotifications = registerPlugin<LocalNotificationsBridge>('LocalNotifications');
